import React, { useState } from "react";
import { Helmet } from "react-helmet-async"; // 1. Helmet'i import et
import { Grid } from "@mui/system";
import AboutMe from './AboutSection';
import HeroSection from './HeroSection';
import Navbar from './Navbar';
import Services from './Services';
import WorkExperience from './WorkExperience';

// SEO için Dil Bazlı Meta İçerikleri
const seoTranslations = {
  tr: {
    title: "İdris Aktaş | Ön Yüz (Frontend) Geliştirici & Portfolyo",
    description: "React, React Native ve TypeScript ile geliştirilmiş modern web ve mobil projeler. İdris Aktaş'ın profesyonel deneyimleri ve geliştirici portfolyosu.",
    keywords: "İdris Aktaş, Frontend Developer, React Geliştirici, Web Tasarım, Portfolyo, Adana Yazılım",
  },
  en: {
    title: "İdris Aktaş | Frontend Developer & Portfolio",
    description: "Modern web and mobile projects developed with React, React Native, and TypeScript. Professional experiences and developer portfolio of İdris Aktaş.",
    keywords: "İdris Aktaş, Frontend Developer, React Developer, Web Development, Portfolio, Mobile Apps",
  }
};

function Home() {
  const [lang, setLang] = useState("tr");
  const normalizedLang = lang.toLowerCase();
  const seo = seoTranslations[normalizedLang] || seoTranslations.tr;

  return (
    <Grid>
      {/* 2. Google Botlarına Dinamik SEO Bilgisi Gönderme */}
      <Helmet>
        <html lang={normalizedLang} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        
        {/* Open Graph (Sosyal Medya Paylaşımları İçin - LinkedIn, Twitter vs.) */}
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://idrisaktas.live" /> {/* Kendi domainini yazmalısın */}
        <meta property="og:image" content="https://idrisaktas.live/practices.jpg" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
      </Helmet>

      <Navbar currentLang={lang} onLangChange={setLang} />

      <div id="hero">
        <HeroSection currentLang={lang} />
      </div>

      <div id="about">
        <AboutMe currentLang={lang} />
      </div>

      <div id="services">
        <Services currentLang={lang} />
      </div>

      <div id="experience">
        <WorkExperience currentLang={lang} />
      </div>
    </Grid>
  );
}

export default Home;